import { Box, Button, InputBase, Paper, Typography } from "@mui/material";
import HomePageStyles from "./HomeMobile.module.css";
import { useState } from "react";
import validator from "validator";
import { backendHosts } from "../../../ui-utils/apiConfig";
import en from "../../../i18n/English/Home/home.json";
import hi from "../../../i18n/Hindi/Home/home.json";
import kn from "../../../i18n/Kannada/Home/home.json";
import ma from "../../../i18n/Marathi/Home/home.json";
import gu from "../../../i18n/Gujarati/Home/home.json"
import bb from "../../../ui-utils/latestPics/bb.svg"
import { useLanguage } from "../../../Context/LangContext";
export default function HomeMobile() {
  const [mobileNo, setMobileNo] = useState("");
  const clientErr = {};
  const [mobClientErr, setMobileClientErr] = useState({});

    const { language } = useLanguage();
    const translations = { en, hi, kn ,gu,ma };
    const t = translations[language];

  const handleMobilenoEnter = () => {
    const formData = { mobileNo };
    console.log(formData);
    const runValidation = () => {
      if (mobileNo.trim().length == 0) {
        clientErr.mobileNo = "Please enter your mobile number.";
        return;
      }
      if (!validator.isMobilePhone(mobileNo, "en-IN")) {
        clientErr.mobileNo = "Please enter a valid mobile number.";
        return;
      }
    };
    runValidation();
    if (Object.keys(clientErr).length == 0) {

      const fullUrl = `${backendHosts.REG}/?mobilenofromhome=${mobileNo}&t=${Date.now()}`;
      window.location.href = fullUrl;
      setMobileClientErr({});

    } else {
      setMobileClientErr(clientErr);
    }
  };

  const handleMobileNoChange = (e) => {
    const inputValue = e.target.value;
    const numericValue = inputValue.replace(/\D/g, "");
    const limitedValue = numericValue.slice(0, 10);

    setMobileNo(limitedValue);
  };

  return (
    <>
      <Box className={HomePageStyles.HomeSectionBox}>
        {/* <video
          className={HomePageStyles.video}
          ref={(el) => {
            if (el) el.muted = true;
          }}
          autoPlay
          loop
          playsInline
          webkit-playsinline="true"
          preload="auto"
          controls={false}
        >
          <source src={bg} type="video/mp4" />
        </video> */}

        <div className={HomePageStyles.bgWrapper}>
          <img
            src={bb}
            alt="Background slideshow"
            className={HomePageStyles.bgImage}
          />
          <img
            src={bb}
            alt="Background slideshow"
            className={HomePageStyles.bgImage}
          />
        </div>

        <Box className={HomePageStyles.subHomeSection}>
          <Typography className={HomePageStyles.homeHeading}>
            {t.text1} <br /> {t.text2}
          </Typography>




              {/* <Typography
                className={HomePageStyles.homeSubHeading}
                sx={{ lineHeight: "1.5" }} // aligns bullet vertically
              >
                ○
              </Typography> */}
              <Typography
                className={HomePageStyles.homeSubHeading}
                sx={{ lineHeight: "1.5", }} // restrict width to wrap
              >
                {t.points[0]}
              </Typography>



              {/* <Typography
                className={HomePageStyles.homeSubHeading}
                sx={{ lineHeight: "1.5" }}
              >
                ○
              </Typography> */}
              <Typography
                className={HomePageStyles.homeSubHeading}
                sx={{ lineHeight: "1.5" }}
              >
                {t.points[1]}
              </Typography>
        </Box>


        <Paper component="form" className={HomePageStyles.mobilefield}>
          <Typography className={HomePageStyles.preMobile}>
            91
          </Typography>

          <InputBase
            className={HomePageStyles.inputbase}
            name="mobileNo"
            type="tel"
            placeholder={t.placeholder}
            autoComplete="tel-national"
            inputProps={{
              "aria-label": "Mobile Number",
              inputMode: "numeric",
            }}
            onChange={handleMobileNoChange}
            value={mobileNo}
          />
        </Paper>

          {mobClientErr.mobileNo && (
            <Typography className={HomePageStyles.errMsgg}>
              {mobClientErr.mobileNo}
            </Typography>
          )}
          <Button
            variant="contained"
            onClick={handleMobilenoEnter}
            className={HomePageStyles.dematButton}
          >
            {t.dematButton}
          </Button>
        </Box>

    </>
  );
}
